<template>
  <svg class="svg-icon" :class="iconName" aria-hidden="true" v-on="$listeners">
    <use :xlink:href="`#icon-${iconName}`"/>
  </svg>
</template>

<script>
export default {
  name: 'SvgIcon',
  props: {
    iconName: {
      type: String,
      required: true,
    },
  },
};
</script>
